// TODO: Fix eslint errors.
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable write-good-comments/write-good-comments */
/* eslint-disable react/jsx-key */
/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
/* eslint-disable guard-for-in */
/* eslint-disable no-plusplus */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */

import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { Link, useRouteMatch, useHistory } from 'react-router-dom';
import SearchForm from '@Filters/SearchForm';
import Accordion from '@UI/Accordion';
import AccordionItem from '@UI/AccordionItem';
import Checkbox from '@UI/Checkbox';
import Filter from '@UI/Filter';
import Button from '@UI/Button';
import searchParamsStringify from '@Utils/searchParamsStringify';
import { facetHref } from 'facetsHelper';

function BlogFilter({
  intl, pageType, searchParams, resultsTotal,
}) {
  const route = useRouteMatch();
  const baseUrl = route.path.replace(':searchParams*', '');
  const history = useHistory();
  const filters = searchParams.facets ? { ...searchParams.facets } : {};

  const [state, setState] = useState({
    search: searchParams.query ? searchParams.query : '',
  });

  const onChange = (event) => {
    const { name } = event.target;
    const { facetType } = event.target.dataset;
    const params = { ...searchParams, ...{ page: null } };
    params.facets[facetType][name].checked = event.target.checked;

    history.push(`${baseUrl}${searchParamsStringify(pageType, params)}`);
  };

  const onSubmit = () => {
    searchParams.page = null;

    const baseUrl = route.path.replace(':searchParams*', '');
    const params = searchParamsStringify(pageType, { ...searchParams, ...{ query: state.search || null } });
    history.push(`${baseUrl}${params}`);
  };

  const accordionItems = [];
  for (const facetType in filters) {
    if (filters.hasOwnProperty(facetType) && Object.keys(filters[facetType]).length) {
      const facetItems = filters[facetType];
      const facetFilters = [];
      const checkboxInputProps = [];

      let checkboxKey = '';
      for (const facetId in facetItems) {
        const facetData = facetItems[facetId];
        // Undefined as a string is the case where an invalid category parameter is typed manually in the URL.
        // Invalid means that it does not exists as a facet in elastic.
        if (facetId !== 'undefined') {
          checkboxKey = facetId;
          checkboxInputProps.push({
            key: facetData.key,
            name: facetData.name,
            checked: facetData.checked,
            href: `${baseUrl}${facetHref(facetId, searchParams, pageType)}`,
            label: facetData.name,
            onChange,
            data: {
              'data-facet-type': facetType,
            },
          });
        }
      }

      facetFilters.push(
        <Checkbox key={checkboxKey} label={facetType}>
          {checkboxInputProps.map(({ data, ...props }) => <item {...props} {...data} />)}
        </Checkbox>,
      );

      accordionItems.push(
        <AccordionItem
          key={facetType}
          id={`sidebar-filter-${facetType}`}
          title={intl.messages[`BlogFilter.${facetType}`] ? intl.formatMessage({ id: [`BlogFilter.${facetType}`] }) : facetType}
          expanded
          HeadingTag="h2"
          ariaLabel={intl.formatMessage({ id: 'AccordionItem.AriaLabel' })}
        >
          {facetFilters}
        </AccordionItem>,
      );
    }
  }

  let filterCount = searchParams.query ? 1 : 0;
  if (searchParams.facets) {
    for (const facetType in searchParams.facets) {
      if (searchParams.facets.hasOwnProperty(facetType)) {
        for (const [, value] of Object.entries(searchParams.facets[facetType])) {
          if (value.checked) {
            filterCount++;
          }
        }
      }
    }
  }

  return (
    <Filter
      title={intl.formatMessage({ id: 'SearchFilters.FilterTitle' })}
      mobileTitle={intl.formatMessage({ id: 'SearchFilters.FilterTitle' })}
      footer={(
        <Button fullWidth type="filled" onClick={onSubmit}>
          {intl.formatMessage(
            { id: 'Blog.ResultCount' },
            { count: resultsTotal },
          )}
        </Button>
   )}
      clearLink={
filterCount ? (
  <Link
    className="link"
    to={route.path.replace(':searchParams*', '')}
    onClick={() => {
      setState({ search: '' });
    }}
  >
    {intl.formatMessage(
      { id: 'SearchForm.ClearSearch' },
      { filterCount },
    )}
  </Link>
) : null
}
    >
      <SearchForm
        pageType={pageType}
        searchParams={searchParams}
        state={state}
        setState={setState}
        onSubmitCb={onSubmit}
      />
      <Accordion>{accordionItems}</Accordion>
    </Filter>
  );
}
export default injectIntl(BlogFilter);
